import Footer from "./components/Footer";
import Header from "./components/Header";
import AllRouts from "./routes/AllRouts";


function App() {
  return (
    <div className="App">
      <Header/>
      <AllRouts/>
      <Footer />
    </div>
  );
}

export default App;
